/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Action_UnarchiveInputs */

const fr_vehicle_action_unarchive = /** @type {(inputs: Vehicle_Action_UnarchiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Désarchiver`)
};

const en_vehicle_action_unarchive = /** @type {(inputs: Vehicle_Action_UnarchiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unarchive`)
};

/**
* | output |
* | --- |
* | "Unarchive" |
*
* @param {Vehicle_Action_UnarchiveInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const vehicle_action_unarchive = /** @type {((inputs?: Vehicle_Action_UnarchiveInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Action_UnarchiveInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_vehicle_action_unarchive(inputs)
	return en_vehicle_action_unarchive(inputs)
});